import payment from 'payment'

export const isValidCardNumber = (value = '') => {
  const sanitized = value.replace(/\D/g, '')
  if (!value) return true

  return payment.fns.validateCardNumber(sanitized)
}
